<template>
  <StaticDataTable class="static-table-list">
    <template v-slot:header>
      <tr>
        <th>Type</th>
        <th>Item (HxW)</th>
        <th>Alloc (HxW)</th>
        <th>Barcode</th>
        <th>Cutting Due</th>
        <th>Customer</th>
        <th>Order</th>
        <th>Order Status</th>
        <th>Info</th>
        <th>Mark</th>
      </tr>
    </template>
    <template v-slot:body v-if="allocationList">
      <tr v-for="allocation of allocationList" :key="allocation.id">
        <td class="font-weight-bold">
          {{formatLookupName(allocation.type, SheetAllocationTypeLookup)}}
        </td>
        <td>{{generateAllocContentSizeLabel(allocation)}}</td>
        <td>{{generateAllocRegionSizeLabel(allocation)}}</td>
        <td>
          <LinkProductionPanel
            v-if="allocation.type == SheetAllocationTypes.panel && allocation.productionPanel"
            :id="allocation.productionPanel.id"
            :name="allocation.productionPanel.barcode"
            :disabled="!linksEnabled"
          />
          <span v-if="allocation.type == SheetAllocationTypes.offcut && allocation.glassLevel">{{allocation.glassLevel.barcode}}</span>
        </td>
        <td>
          <span v-if="(allocation.type == SheetAllocationTypes.panel || allocation.type == SheetAllocationTypes.splitPanel) && allocation.dateDue">{{formatDateCustom(allocation.dateDue, 'h:mma Do MMM')}}</span>
          <span v-else>-</span>
        </td>
        <td>
          <LinkOrder
            v-if="(allocation.type == SheetAllocationTypes.panel || allocation.type == SheetAllocationTypes.splitPanel) && allocation.order"
            :id="allocation.order.contact.id"
            :name="allocation.order.contact.name"
            :disabled="!linksEnabled"
          />
          <span v-else>-</span>
        </td>
        <td>
          <LinkOrder
            v-if="(allocation.type == SheetAllocationTypes.panel || allocation.type == SheetAllocationTypes.splitPanel) && allocation.order"
            :id="allocation.order.id"
            :name="allocation.order.sequenceNumber"
            :disabled="!linksEnabled"
          />
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="(allocation.type == SheetAllocationTypes.panel || allocation.type == SheetAllocationTypes.splitPanel) && allocation.order">
            <LabelOrderStatusBadge
              :status="allocation.order.status"
              :isOnHold="allocation.order.isOnHold"
              :holdType="allocation.order.holdType"
              :isUrgent="allocation.order.isUrgent"
            />
          </span>
          <span v-else>-</span>
        </td>
        <td>
          <LabelBadge labelClass="label-order-type-nonChargeableRework" v-if="allocation.type == SheetAllocationTypes.panel && allocation.productionPanel && allocation.productionPanel.isRecut">Recut</LabelBadge>
        </td>
        <td>{{generateAllocMarkLabel(allocation)}}</td>
      </tr>
    </template>
    <template v-slot:empty v-if="!allocationList || allocationList.length == 0">No allocations</template>
  </StaticDataTable>
</template>


<script>
import LabelSheetStatusBadge from '@/modules/optimiser/components/labelSheetStatusBadge'
import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'

import { LinkTypes, OptimiserSheetStatusTypes, SheetAllocationTypes, SheetAllocationTypeLookup } from '@/store/types'

export default {
  name: 'OptimiserAllocationList',
  components: {
    LabelSheetStatusBadge,
    LabelOrderStatusBadge
  },
  props: {
    allocationList: Array,
    linksEnabled: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.LinkTypes = LinkTypes
    this.SheetAllocationTypes = SheetAllocationTypes
    this.SheetAllocationTypeLookup = SheetAllocationTypeLookup
  },
  methods: {
    generateAllocContentSizeLabel(allocation) {
      let width = allocation.width
      let height = allocation.height

      if(allocation.type == SheetAllocationTypes.panel) {
        width = allocation.productionPanel.panelWidth
        height = allocation.productionPanel.panelHeight
      }
      if(allocation.type == SheetAllocationTypes.offcut) {
        width += allocation.overflowLeft + allocation.overflowRight
        height += allocation.overflowTop + allocation.overflowBottom
      }

      return `${height} x ${width}`
    },
    generateAllocRegionSizeLabel(allocation) {
      let width = allocation.width
      let height = allocation.height

      return `${height} x ${width}`
    },
    generateAllocBarcodeLabel(allocation) {
      if(allocation.type == SheetAllocationTypes.panel && allocation.productionPanel)
        return allocation.productionPanel.barcode
      if(allocation.type == SheetAllocationTypes.offcut && allocation.glassLevel)
        return allocation.glassLevel.barcode
      return '-'
    },
    generateAllocOrderLabel(allocation) {
      if(allocation.type == SheetAllocationTypes.panel)
        return allocation.order.sequenceNumber
      return '-'
    },
    generateAllocMarkLabel(allocation) {
      if(allocation.type == SheetAllocationTypes.panel)
        return allocation.orderItem.mark || '-'
      if(allocation.type == SheetAllocationTypes.blankPanel)
        return allocation.userInfo || '-'
      return '-'
    }
  }

}
</script>